/* eslint-disable max-len */
import React, {
    useCallback,
    useState,
    useContext,
    useEffect
} from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLBundleService } from 'ml-services-common-react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLModalService } from 'ml-portals-services-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PUMBTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PUMBTrackEvent';
import EsignatureComponent from 'gw-capability-quoteandbind-common-react/components/EsignatureComponent/EsignatureComponent';
import { UserService } from 'gw-capability-gateway';
import metadata from './PUPAdditionalInfoToPurchasePage.metadata.json5';
import messages from './PUPAdditionalInfoToPurchasePage.messages';
import {PriorMetSubmissionPopupMessages as priorMetPopupMessages,PriorMetSubmissionPopup as priorMetPopup, PriorMetSubmissionPopupStyles as priorMetPopupStyles} from 'ml-capability-quoteandbind-common-react';
import { MLUWIssuesPanelComponent } from "gw-capability-gateway-quoteandbind-common-react";
import styles from './PUPAdditionalInfoToPurchasePage.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import { AccountService } from 'gw-capability-gateway-policy';
import { MLProductCodeUtil } from 'ml-portals-util-js';
import { useModal } from '@jutro/components';
import moment from 'moment';

const PUPAdditionalInfoToPurchasePage = (props) => {
    const isGPA = appConfig.portalCode === 'GPA';
    const {
        wizardData: submissionVM,
        updateWizardData,
        goNext,
        history
    } = props;
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const vehiclesVM = pupModel.coverables.vehicles.filter(() => true);
    const [showErrors, updateShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [additionalInterestAvailableCandidatesML, setAdditionalInterestAvailableCandidatesML] = useState([]);
    const [isValidVin, updateIsValidVin] = useState(false);
    const [inValidVin, setInValidVin] = useState([]);
    const [disableNextButton, setDisableNextButton] = useState(false);
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(false);
    const [blockingUwIssues, setBlockingUwIssues] = useState([]);
    const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';
    const BOOKROLL_QUOTE_ASSIST = "quote_assist" 
    const BOOKROLLTYPE_QUOTE_ASSIST = "quote_assist"
    const BOOKROLLTYPE_CAREER_BOOK_TRANSFER = 'carrier_book_transfer';
    const BOOKROLLTYPE_INDEPENDENT_AGENT_BOOKROLL = 'independent_agent_book_roll';
    const invalidBookRollTypeCombination = ['MultLineCurrentInsuranceProviderNoPriorInsurance_Ext', 'MultLineCurrentInsuranceProviderFarmers_Ext']
    const modalApi = useModal()
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const nonDriverTypes = ['nondriver', 'outofhousehold','permitted'];
    const {nextStepVisited} = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const productCode = submissionVM.baseData.productCode.value;
    const priorInsuranceQuestionSetData = _.get(submissionVM.lobData, 'personalUmbrella.priorInsurance.value[0]');
    const isHomeowners = MLProductCodeUtil.isHomeOwners(submissionVM.baseData.productCode.value);
    const isPersonalUmbrella = MLProductCodeUtil.isPersonalUmbrella(submissionVM.baseData.productCode.value);
    const isUmUimCoverageSelected = _.get(submissionVM.value, "lobData.personalUmbrella.offerings[0].coverages.prsnlAutoExcessCoverages[0].selected");
    const quoteID = submissionVM.quoteID.value;
    const isEnableEsign_State= _.get(submissionVM,'enableEsign_State.value','')
    const userState = _.get(submissionVM, 'baseData.policyAddress.state.value.code','')
    const isEsignEnabledForState = isEnableEsign_State.split(',').map(state => state.trim()).includes(userState);

    const {
        addWarningAlert,
        addErrorAlert,
        clearBlockAlerts,
        clearErrorAlerts
    } = MLNotificationBlockUtil();

    const { refreshData } = useDataRefresh();

    useEffect(() => { 
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PUMBTrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'PUMB Additional Info Prebind Page'});
            });
        }
    }, []);

    useEffect(() => {
        LoadSaveService.getAdditionalInterestCandidatesML(submissionVM.quoteID.value, authHeader).then((candidates) => {
            setAdditionalInterestAvailableCandidatesML(candidates);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hasAnyNonApprovedUwIssue = (allUwIssues) => {
        if (allUwIssues && allUwIssues.length > 0) {
            return allUwIssues.some(elem => elem.hasApprovalOrRejection === false && elem.initialBlockingPoint_ML !== 'NonBlocking')
        }

        return false;
    };

    const checkForPUPAdditionalInfoToPurchaseUwIssues = () => {
        // get the selected quote version
        const selectedVersion = _.get(submissionVM, 'bindData.value.chosenQuote', "");
        // get the offering object for the selected version from offeredQuotes
        const offeringObj = _.find(_.get(submissionVM, 'quoteData.value.offeredQuotes', ""), { publicID: selectedVersion });
        // get the uwIssues_ML from the offering object
        const uwIssues = offeringObj?.uwIssues_ML;

        if (uwIssues?.length > 0 && hasAnyNonApprovedUwIssue(uwIssues)) {
            setIsUWIssuesPanelVisible(true);
            setBlockingUwIssues(uwIssues);
            setDisableNextButton(true);
            return true;
        }

        setDisableNextButton(false);
        return false;
    }

    const checkForDisableNextButton = useCallback((issues) => {
        if (issues?.length > 0 && hasAnyNonApprovedUwIssue(issues)) {
            setDisableNextButton(true);
        } else {
            setDisableNextButton(false);
        }
    }, []);

    const isPriorInsuranceMetOrFarmers = useCallback(() => {
        const answer = _.get(priorInsuranceQuestionSetData, 'answers.MultLineCurrentInsuranceProvider_Ext');
        return answer === 'MultLineCurrentInsuranceProviderFarmers_Ext' || answer === 'MultLineCurrentInsuranceProviderMetLifePropCas_Ext';
    }, [priorInsuranceQuestionSetData]);

    const isPriorInsuranceAnswerValid = useCallback(() => {
        const answer = _.get(priorInsuranceQuestionSetData, 'answers.MultLineCurrentInsuranceProvider_Ext');
        const carrierAnswer = _.get(priorInsuranceQuestionSetData, 'answers.MultiLineCarrierNotListed_Ext');
        return !(answer === 'MultLineCurrentInsuranceProviderOtherNotListed_Ext' && _.isNil(carrierAnswer));
    }, [priorInsuranceQuestionSetData]);

    const checkForInvalidBookrollCombination = () => {
        setDisableNextButton(false);
        clearBlockAlerts('InvalidInsuranceProviderForBookRoll');
        const insurerAnswer = _.get(priorInsuranceQuestionSetData, 'answers.MultLineCurrentInsuranceProvider_Ext');
        const isBookRoll = _.get(submissionVM, 'bookrollInd_ML.value.code');
        const bookRollType = _.get(submissionVM, 'bookRollType_Ext.value.code');
        if((isBookRoll !== undefined && isBookRoll !== null && (isBookRoll === BOOKROLL_WITHOUT_RATE_CAPPING || isBookRoll === BOOKROLL_QUOTE_ASSIST))
&& (bookRollType !== undefined && bookRollType !== null 
&& (bookRollType === BOOKROLLTYPE_CAREER_BOOK_TRANSFER || bookRollType === BOOKROLLTYPE_INDEPENDENT_AGENT_BOOKROLL || bookRollType === BOOKROLLTYPE_QUOTE_ASSIST))
&& invalidBookRollTypeCombination.includes(insurerAnswer)){
                return true;
            }
        return false;
    }

    const syncPriorInsuranceQuestionSets = () => {
        setDisableNextButton(false);
        const syncPromise = LoadSaveService.syncQuestionSetML(quoteID, [priorInsuranceQuestionSetData], authHeader);
        showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
        syncPromise.then((updatedQuestionSets) => {
            const priorInsuranceQs = updatedQuestionSets.find((q) => q.code === 'PriorInsuranceMultiLine_Ext');
            _.set(submissionVM, 'lobData.personalUmbrella.priorInsurance.value[0]', priorInsuranceQs);
            updateWizardData(submissionVM);
            refreshData();
        }).catch(error => {
            // US963263: Handle CDC Exceptions using Generic Error Handler
            hideProgressDialog();
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        });
    };

    const validateNoPriorCarrierOrNoInsurance = () => {
        if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            clearBlockAlerts('NoCarrierError');
            const message = translator(messages.NoCarrierError);
            const currentCompanyErrormessage = translator(messages.CurrentCompany);
            const companyPolicyErrormessage = translator(messages.CompanyPolicyNumber);
            const effDateErrormessage = translator(messages.OriginalEffectiveDate);
            const insurerAnswer = _.get(priorInsuranceQuestionSetData, 'answers.MultLineCurrentInsuranceProvider_Ext');
            const subCompany = _.get(priorInsuranceQuestionSetData, 'answers.MultLineFarmersSubCompany_Ext');
            const policyNumber = _.get(priorInsuranceQuestionSetData, 'answers.MultiLinePolicyNumber_Ext');
            const effDate = _.get(priorInsuranceQuestionSetData, 'answers.MultiLineTenureEffDate_Ext');
            const invalidCombinationForBookRollType = checkForInvalidBookrollCombination();
            if (insurerAnswer === undefined || insurerAnswer === null) {
                addErrorAlert(message, 'NoCarrierError');
                window.scrollTo(0, 0);
                return true;
            } else if(insurerAnswer === "MultLineCurrentInsuranceProviderFarmers_Ext" && (subCompany === undefined || subCompany === null)) {
                addErrorAlert(currentCompanyErrormessage,'NoCarrierError');
                window.scrollTo(0, 0);
                return true;
            } else if(insurerAnswer === "MultLineCurrentInsuranceProviderFarmers_Ext" && (_.isUndefined(policyNumber) || policyNumber === null || policyNumber.length > 25 || !/^[a-zA-Z0-9]+$/.test(policyNumber))) {
                addErrorAlert(companyPolicyErrormessage,'NoCarrierError');
                window.scrollTo(0, 0);
                return true;
            } else if(insurerAnswer === "MultLineCurrentInsuranceProviderFarmers_Ext" && (_.isUndefined(effDate) || effDate === null)) {
                if(!OriginalEffectiveDate()) {
                    addErrorAlert(effDateErrormessage,'NoCarrierError');
                } else {
                    addErrorAlert(effDateErrormessage,'NoCarrierError');
                }
                window.scrollTo(0, 0);
                return true;
            }
            else if(invalidCombinationForBookRollType){
                const message = translator(messages.InvalidInsuranceProviderForBookRoll);
                addErrorAlert(message, 'InvalidInsuranceProviderForBookRoll');
                window.scrollTo(0, 0);
                return true;
            }
        }
        return false;
    };

    const onPriorInsuranceQuestionValueChange_Ext = useCallback((questionSetAnswers, path, qsQuestionType) => {
        clearBlockAlerts('NoCarrierError');
        if(checkForInvalidBookrollCombination()){
            const message = translator(messages.InvalidInsuranceProviderForBookRoll);
            addErrorAlert(message, 'InvalidInsuranceProviderForBookRoll');
            window.scrollTo(0, 0);
        }
        if (qsQuestionType !== 'String' &&  qsQuestionType !== 'Integer' && qsQuestionType !== 'Date') {
            syncPriorInsuranceQuestionSets();
        } else {
            _.set(submissionVM, 'lobData.personalUmbrella.priorInsurance.value[0]', questionSetAnswers);
            refreshData();
        }
        updateWizardData(submissionVM);
    }, [refreshData, submissionVM, syncPriorInsuranceQuestionSets, updateWizardData]);

    const handlePriorInsuranceOnBlur = useCallback((evt, inputObj, qsQuestionType, aQuestionSetAnswersValue) => {
        // check if progress dialog is causing the onBlur event and if so, do not trigger another sync call
        const isTargetModal = evt?.relatedTarget?.className?.indexOf('ml-modal-loading') > -1;
        if ((qsQuestionType === 'String' || qsQuestionType === 'Integer' || qsQuestionType === 'Date') && !isTargetModal) {
            syncPriorInsuranceQuestionSets();
            updateWizardData(submissionVM);
        }
    }, [submissionVM, syncPriorInsuranceQuestionSets, updateWizardData]);

    const OriginalEffectiveDate = useCallback(() => {
        const originalDate = _.get(submissionVM, 'lobData.personalUmbrella.priorInsurance.value[0].answers.MultiLineTenureEffDate_Ext');
        const originalDateMessage = translator(messages.OriginalEffectiveDate);
        const futureDateMessage = translator(messages.FutureEffectiveDate);
        clearErrorAlerts();
        if (!_.isUndefined(originalDate) && originalDate !== null ) {
            const dateIsValid = moment(originalDate, "MM/YYYY", true).isValid();
            if (dateIsValid === true) {
                const [month, year] = originalDate.split('/');
                const convertMonthYearToActualDate = new Date(`${month}/01/${year}`);
                if (convertMonthYearToActualDate.getTime() > Date.now()) {
                    addErrorAlert(futureDateMessage);
                    return true;
                }
            } else {
                addErrorAlert(originalDateMessage);
                return true;
            }
        }
        return false;
    }, [addErrorAlert, clearErrorAlerts, submissionVM, translator]);

    const showPriorMetSubmissionPopup = useCallback(() => {
        const disableButton = () => {
            return _.isUndefined(_.get(submissionVM, 'baseData.newPolicyReason_Ext.value', undefined));
        };

        const newPolicyReasonHelpTextMap = {
            insuring_same_location_diff_policy_form: translator(priorMetPopupMessages.sameLocationPriorMetTooltipContent)
        };

        if(validateNoPriorCarrierOrNoInsurance()){
            return false
        }

        const newPolicyReasonHelpTextTitleMap = {
            insuring_same_location_diff_policy_form: translator(priorMetPopupMessages.sameLocationPriorMetTooltipTitle)
        };

        const mapAvailableValues = (values) => {
            if (submissionVM.isSubmitAgent.value === true) {
                values = values.filter((reason) => reason.code !== 'purchase_direct');
            }

            return values.map((type) => {
                return {
                    code: type.code,
                    name: translator({
                        id: type.name,
                        defaultMessage: type.name
                    })
                };
            });
        };

        const overrides = {
            newPolicyReasonRadioButtons: {
                helpTextTitleMap: newPolicyReasonHelpTextTitleMap,
                helpTextMap: newPolicyReasonHelpTextMap,
                availableValues: mapAvailableValues(_.get(submissionVM, 'baseData.newPolicyReason_Ext.aspects.availableValues', [])),
                value: _.get(submissionVM, 'baseData.newPolicyReason_Ext.value')
            }
        };

        const componentProps = {
            title: translator(priorMetPopupMessages.priorMetPopupHeader),
            uiProps: priorMetPopup.pageContent,
            actionBtnLabel: platformMessages.mlContinue,
            viewModel: submissionVM.baseData,
            disableButton: disableButton,
            modalBodyStyles: priorMetPopupStyles,
            overrideProps: overrides,
            onSaveAction: ((baseDataVM) => {
                const newSubmissionVM = _.clone(submissionVM);
                _.set(newSubmissionVM, 'baseData', baseDataVM);
                updateWizardData(newSubmissionVM);
                return true;
            }),
            showXCloseButton: false
        };
        if (!OriginalEffectiveDate()) {
            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        }
    }, [submissionVM, translator, updateWizardData, OriginalEffectiveDate]);
    

    let hasDuplicateLicenseNumber;

    const isDriver = (vehicleOperatorVM) => {
        switch (vehicleOperatorVM.driverType.value.code) {
            case 'rated':
            case 'excluded':
                return true;
            default:
                return false;
        }
    };

    const shouldPrefillEmailAddress = () => {
        const prefillCandidate = MLBundleService.getPrefillEmailCandidate();

        return submissionVM.isBundle_ML.value && prefillCandidate && prefillCandidate.emailAddress;
    };

    const setPrimaryEmailProperties = (operator) => {
        const hasEmailAddress = !_.isUndefined(operator.emailAddress) && operator.emailAddress !== '';
        operator.isEmailAddressRequired = !(!hasEmailAddress && submissionVM.quoteData.offeredQuotes.value[0].commPreference_ML === 'paper');
        if (shouldPrefillEmailAddress()) {
            const prefillFrom = MLBundleService.getPrefillEmailCandidate();
            operator.emailAddress = prefillFrom.emailAddress;
        }
    };

    const initVehicleOperator = (vehicleOperatorVM) => {
        vehicleOperatorVM.contact.updated.value = true;
        vehicleOperatorVM.isAgeFirstLicensedRequired.value = true;
        vehicleOperatorVM.isOccupationTypeRequired.value = true;

        if (isDriver(vehicleOperatorVM)) {
            vehicleOperatorVM.isLicenseNumberRequired.value = true;
            vehicleOperatorVM.isLicenseStateRequired.value = true;
        } else {
            vehicleOperatorVM.isLicenseNumberRequired.value = false;
            vehicleOperatorVM.isLicenseStateRequired.value = false;
        }

        if (vehicleOperatorVM.isPrimaryNamedInsured.value) {
            vehicleOperatorVM.isHasLossWithin5YearsRequired.value = true;
            setPrimaryEmailProperties(vehicleOperatorVM.value);
        } else {
            if (vehicleOperatorVM.relationshipToInsured.value === 'spouse' && _.get(submissionVM, 'baseData.policyAddress.state.value.code') === 'CO') {
                vehicleOperatorVM.isEmailAddressRequired.value = true;
            } else {
                vehicleOperatorVM.isEmailAddressRequired.value = false;
            }
            vehicleOperatorVM.isHasLossWithin5YearsRequired.value = false;
        }

        vehicleOperatorVM.value.hasEmailAddressInput = !!vehicleOperatorVM.emailAddress.value;
        vehicleOperatorVM.editMode_ML.value = true;
        return vehicleOperatorVM;
    };

    const vehicleOperatorsVM = pupModel.coverables.vehicleOperators.filter((vehicleOperatorVM) => initVehicleOperator(vehicleOperatorVM));
    const ratedDriversVM = vehicleOperatorsVM.filter((vehicleOperatorVM) => vehicleOperatorVM.driverType.value.code === 'rated');
    const householdMembersVM = vehicleOperatorsVM.filter((vehicleOperatorVM) => vehicleOperatorVM.driverType.value.code === 'household' || nonDriverTypes.includes(vehicleOperatorVM?.driverType?.value?.code));
    const excludedDriversVM = vehicleOperatorsVM.filter((vehicleOperatorVM) => vehicleOperatorVM.driverType.value.code === 'excluded');

    useEffect(() => {
        vehicleOperatorsVM.forEach((operator) => {
            operator.value.originalEmailAddress = _.get(operator, 'emailAddress.value');
        });
    }, []);

    const initWatercraftOperator = (watercraftOperatorVM) => {
        watercraftOperatorVM.isYearsOfExperienceRequired.value = true;
        return watercraftOperatorVM;
    };

    const watercraftOperatorsVM = pupModel.coverables.watercraftOperators.filter((watercraftOperatorVM) => initWatercraftOperator(watercraftOperatorVM));

    const {
        onValidate,
        isComponentValid
    } = useValidation('PUPAdditionalInfoToPurchasePage');

    const onLicenseNumberChange = () => {
        const allLicenseNumbers = watercraftOperatorsVM.map((operator) => operator.value.licenseNumber); // ['123', '123']     
        const licenseNumbersCount = allLicenseNumbers.reduce((accumulator, currentValue) => {
            accumulator[currentValue] = accumulator[currentValue] || 0;
            accumulator[currentValue]++;

            return accumulator;
        }, {});       

        hasDuplicateLicenseNumber = false; 
        Object.values(licenseNumbersCount).forEach((count) => {
            if (count > 1) {
                hasDuplicateLicenseNumber = true; 
            }
        });
    };

    const getDriverTypeDisplayName = (driverType, isSingular) => {
        switch (driverType) {
            case 'rated':
                return isSingular ? translator(messages.driver) :
                    translator(messages.drivers);
            case 'excluded':
                return isSingular ? translator(messages.excludedDriver) :
                    translator(messages.excludedDrivers);
            case 'household':
                return isSingular ? translator(messages.householdMember) :
                    translator(messages.householdMembers);
            default:
                return '';
        }
    };

    const isEmailAddressVisible = (vehicleOperatorVM) => {
        return (vehicleOperatorVM.isPrimaryNamedInsured.value === true) || _.get(vehicleOperatorVM, 'emailAddress.aspects.required') ||
        (vehicleOperatorVM.relationshipToInsured.value.code === 'spouse' && _.get(submissionVM, 'baseData.policyAddress.state.value.code') === 'CO') ||
        ((vehicleOperatorVM.contact.value.address.state === 'GA' || vehicleOperatorVM.contact.value.address.state === 'UT' ||
        vehicleOperatorVM.contact.value.address.state === 'OR') && vehicleOperatorVM.driverType.value.code === 'excluded') || ((excludedDriversVM.length !== 0) &&
        (vehicleOperatorVM.relationshipToInsured.value.code === 'spouse') && (vehicleOperatorVM.contact.value.address.state === 'OR'));
    };

    const isVehiclePrivateOrClassic = (vehicleVM) => {
        switch (vehicleVM.type.value.code) {
            case 'private_passenger_autos_ml':
            case 'classic_ml':
                return true;
            default:
                return false;
        }
    };

    const getVehicleName = (vehicleVM) => {
        if (isVehiclePrivateOrClassic(vehicleVM)) {
            return `${vehicleVM.value.getYearMakeModelNameML()} ${vehicleVM.trim_ML.value}`;
        }
        return vehicleVM.value.getYearMakeModelNameML();
    };

    const isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal = (vehicleVM) => {
        switch (vehicleVM.type.value.code) {
            case 'trailer_ml':
            case 'GolfCart_ML':
            case 'LowSpeed_ML':
            case 'Other_Personally_Registered':
                return true;
            default:
                return false;
        }
    };

    const nameSuffixTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');

    const getPersonFullName = (operator) => {
        return operator.value.contact.getFullName(nameSuffixTypeList, translator);
    };

    const isVinDuplicated = useCallback((currentVehicle) => {
        const vehicles = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children', []);
        const vehicleVin = currentVehicle.vin;
        const vehiclesWithTheSameVin = vehicles ? vehicles.filter(
            (x) => !_.isUndefined(x.vin.value) && x.vin.value === vehicleVin.value
        ) : [];
        return vehiclesWithTheSameVin.length >= 2;
    }, [submissionVM]);

    const sortAdditionalInterests_Ext = () => {
        const additionalInterests = _.get(submissionVM, 'lobData.personalUmbrella.coverables.additionalInterests.value', []);
        const sortedInterests = _.sortBy(additionalInterests, (interest) => {
            if (interest.publicID) {
                return _.toInteger(interest.publicID.split(':')[1]);
            }
            return undefined;
        });
        _.set(submissionVM, 'lobData.personalUmbrella.coverables.additionalInterests.value', sortedInterests);
    };

    const checkForEmailValidationError = () => {
        let errorReason = false;
        const EmailValidationErr = vehicleOperatorsVM.map((driver, index) => {
            if(driver.emailAddress.value === " "){
                driver.emailAddress.value=undefined;
                errorReason=true;
            }
        })
        return errorReason;
    }

    const checkForUniqueLicenseNumbers = () => {
        clearBlockAlerts('duplicateLicense');

        const drivers = submissionVM.lobData.personalUmbrella.coverables.vehicleOperators.value.filter((d) => {
            return d.licenseNumber && (d.driverType === 'rated' || d.driverType === 'excluded');
        });
        const seen = new Set();
        let hasDuplicate = false;

        drivers.forEach((d) => {
            if (seen.has(d.licenseNumber)) {
                hasDuplicate = true;
            } else {
                seen.add(d.licenseNumber);
            }
        });

        if(hasDuplicate) {
            addErrorAlert(messages.duplicateLicenseError, 'duplicateLicense');
            
            return false;
        }

        return true;
    };

    const onNext = async() => {
         if (isGPA) {
            try {
                const user = await UserService.getCurrentUser(authHeader);
                PUMBTrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'PUMB Additional Info Prebind Page', action: 'PUMB Additional Information Prebind Submitted' });
            } catch (error) {
                if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                    hideProgressDialog();
                    showErrorModal(null, messages.somethingWentWrong);
                }
            }
        }
        clearBlockAlerts('onNextErrorOccured');
        updateShowErrors(false);
        if (vehiclesVM.some((vehicle) => !isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal(vehicle) && !isValidVin)) {
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if (!checkForUniqueLicenseNumbers()) {
            return false;
        }

        if (!isHomeowners && isPriorInsuranceMetOrFarmers() && _.isUndefined(_.get(submissionVM, 'baseData.newPolicyReason_Ext.value', undefined))) {
            showPriorMetSubmissionPopup();
            return false;
        }

        if (validateNoPriorCarrierOrNoInsurance()) {
            return false;
        }

        if (isEsignEnabledForState && isModernProduct && validateEsignFields()) {
            return false;
        }

        if (isModernProduct && validateUmUimFields()) {
            return false;
        }

        if (!hasDuplicateLicenseNumber) {
            const emailValidError = checkForEmailValidationError();
            if (submissionVM.aspects.valid && submissionVM.aspects.subtreeValid && isPriorInsuranceAnswerValid()) {
                _.set(submissionVM, 'portalCurrentStep_ML.value', 'pupAddtlDetails');
                showProgressDialog(platformMessages.saveSubmission);
                try {
                    if (!nextStepVisited()) {
                        const response = await LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader);
                        submissionVM.value = response;
                        sortAdditionalInterests_Ext();
                    }
                    if (checkForPUPAdditionalInfoToPurchaseUwIssues()) {
                        return false;
                    }
                    goNext();
                } catch (error) {
                    if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                        hideProgressDialog();
                        showErrorModal(null, messages.somethingWentWrong)
                    }
                } finally {
                    hideProgressDialog();
                }      
            } else {
                if (isComponentValid && !(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
                    addWarningAlert(messages.errorOccured, 'onNextErrorOccured')
                    window.scrollTo(0, 0);
                }
                updateShowErrors(true);
                setTimeout(()=>{
                    setErrorTimestamp(errorTimestamp+1);
                }, 500);
                return false;
            }
        }
        return false;
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate,
            onNext: onNext
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            esignatureComponent: EsignatureComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent
        }
    };

    const writeValue = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);


    const updateSubmissionVM = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const formatAvailableValues = (viewModel) => {
        if (!viewModel || !viewModel.aspects || !viewModel.aspects.availableValues) {
            return [];
        }
        let availableValues;
        const isOccupation = _.get(viewModel, '_accessorCode') === 'occupationType';
        if (isModernProduct && isOccupation) {
            availableValues = viewModel.aspects.availableValues.filter((value) => {
                return (value.code.endsWith('_np') || value.code === 'military' || value.code === 'other');
            });
        } else {
            availableValues = viewModel.aspects.availableValues.filter((availableValue) => {
                return !availableValue.code.includes('_np');
            });
        }
        return availableValues.map((availableValue) => {
            return {
                code: availableValue.code,
                name: translator({
                    id: availableValue.name,
                    defaultMessage: availableValue.name
                })
            };
        });
    };

    const driversPath = 'lobData.personalUmbrella.coverables.vehicleOperators.children';
    const drivers = _.get(submissionVM, driversPath, []);

    const getBasePath = useCallback((specificDriver) => {
        const driverIndex = drivers.indexOf(specificDriver);
        return `${driversPath}.${driverIndex}`;
    }, [drivers]);

    const disableEmailAddress = (operator) => {
        return (isGPA && !_.get(submissionVM, 'canEditCommunicationsFields_Ext.value') && _.get(operator, 'value.originalEmailAddress'));
    };

    const nextStepText_Ext = () => {
        return <FormattedMessage
            {...messages.nextDescription}
            values={{
                review: (
                    <strong>{translator(messages.reviewForAnyAdditionalActivity)}</strong>
                ),
                mvr: (
                    <strong>{translator(messages.mVRsMayBeRun)}</strong>
                )
            }}
        />;
    };

    const updateInValidVin = (index) => {
        setInValidVin((prev) => {
            if (!prev.includes(index)) {
                return [...prev, index];
            }
           
            return prev;
        });
    }
     
      const removeInValidVin = (index) => {
        setInValidVin((prev) => prev.filter((invalid) => invalid !== index));
    }

    const generateOverrides = () => {
        const vehicleDetailsOverride = vehiclesVM.map((vehicleVM, index) => {

            return {
                [`vehicleName${index}`]: {
                    content: `${getVehicleName(vehicleVM)} (${translator(messages.vehicleNumber, { vehicleNumber: vehicleVM.vehicleNumber_ML.value })})`
                },
                [`vehicleVINLookupComponent${index}`]: {
                    vehicleVM,
                    quoteID: submissionVM.quoteID,
                    isVinDuplicated,
                    onValueChange: (value) => { _.set(vehicleVM, 'vin', value); updateSubmissionVM(submissionVM) },
                    index,
                    visible: isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal(vehicleVM) === false,
                    onValidate,
                    updateVehicleDetails: updateSubmissionVM,
                    isGpa: true,
                    updateIsValidVin,
                    updateInValidVin,
                    removeInValidVin,
                    shouldShowProgressDialog: false,
                    isPUP:isPersonalUmbrella
                },
                [`vehicleVINDiv${index}`]: {
                    visible: isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal(vehicleVM) === false
                },
                [`vehicleSerialNumberDiv${index}`]: {
                    visible: isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal(vehicleVM) === true,
                },
                [`serialNumberInput${index}`]: {
                    value: vehicleVM.serialNumber.value,
                    onValueChange: (value) => { _.set(vehicleVM, 'serialNumber.value', value); updateSubmissionVM(submissionVM) }
                }
            };
        });

        const householdMembersDetailsOverride = householdMembersVM.map((vehicleOperatorVM, index) => {
            const basePath = getBasePath(vehicleOperatorVM);
            return {
                [`householdMemberName${index}`]: {
                    content: `${_.startCase(_.toLower(getPersonFullName(vehicleOperatorVM)))} (${getDriverTypeDisplayName(vehicleOperatorVM.driverType.value.code, true)} #${index + 1})`
                },
                [`householdMembersEmailAddressDiv${index}`]: {
                    visible: isEmailAddressVisible(vehicleOperatorVM) === true
                },
                [`householdMembersEmailScriptContainer${index}`]: {
                    visible: false
                },
                [`householdMembersOccupation${index}`]: {
                    path: `${basePath}.occupationType`,
                    availableValues: formatAvailableValues(vehicleOperatorVM.occupationType),
                    value: vehicleOperatorVM.occupationType.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'occupationType.value', value); updateSubmissionVM(submissionVM)}
                },
                [`householdMembersDriverLicenseNumberContainer${index}`]: {
                    visible: isDriver(vehicleOperatorVM)
                },
                [`householdMembersDriverLicenseNumber${index}`]: {
                    path: `${basePath}.licenseNumber`,
                    value: vehicleOperatorVM.licenseNumber.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'licenseNumber.value', value); updateSubmissionVM(submissionVM) }
                },
                [`householdMembersStateLicensedRowContainer${index}`]: {
                    visible: isDriver(vehicleOperatorVM)
                },
                [`householdMembersStateLicensed${index}`]: {
                    path: `${basePath}.licenseState`,
                    availableValues: formatAvailableValues(vehicleOperatorVM.licenseState),
                    value: vehicleOperatorVM.licenseState.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'licenseState.value', value); updateSubmissionVM(submissionVM) }
                },
                [`householdMembersAgeFirstLicensedRowContainer${index}`]: {
                    visible: isDriver(vehicleOperatorVM)
                },
                [`householdMembersAgeFirstLicensed${index}`]: {
                    path: `${basePath}.ageFirstLicensed`,
                    value: vehicleOperatorVM.ageFirstLicensed.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'ageFirstLicensed.value', value); updateSubmissionVM(submissionVM) }
                },
                [`householdMemberEmailAddress${index}`]: {
                    path: `${basePath}.emailAddress`,
                    value: vehicleOperatorVM.emailAddress.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'emailAddress.value', value); updateSubmissionVM(submissionVM) },
                    disabled: disableEmailAddress(vehicleOperatorVM)
                }
            };
        });

        const excludedDriversDetailsOverride = excludedDriversVM.map((vehicleOperatorVM, index) => {
            const basePath = getBasePath(vehicleOperatorVM);
            return {
                [`excludedDriverName${index}`]: {
                    content: `${getPersonFullName(vehicleOperatorVM)} (${getDriverTypeDisplayName(vehicleOperatorVM.driverType.value.code, true)} #${index + 1})`
                },
                [`excludedDriversEmailAddressDiv${index}`]: {
                    visible: isEmailAddressVisible(vehicleOperatorVM) === true,
                    onBlur: () => {handleOnBlur(vehicleOperatorVM)},
                    onFocus: (event) => {emailTrim(vehicleOperatorVM, event)}
                },
                [`excludedDriversOccupation${index}`]: {
                    path: `${basePath}.occupationType`,
                    availableValues: formatAvailableValues(vehicleOperatorVM.occupationType),
                    value: vehicleOperatorVM.occupationType.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'occupationType.value', value); updateSubmissionVM(submissionVM)}
                },
                [`excludedDriversDriverLicenseNumber${index}`]: {
                    path: `${basePath}.licenseNumber`,
                    value: vehicleOperatorVM.licenseNumber.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'licenseNumber.value', value); updateSubmissionVM(submissionVM) }
                },
                [`excludedDriversStateLicensed${index}`]: {
                    path: `${basePath}.licenseState`,
                    availableValues: formatAvailableValues(vehicleOperatorVM.licenseState),
                    value: vehicleOperatorVM.licenseState.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'licenseState.value', value); updateSubmissionVM(submissionVM) }
                },
                [`excludedDriversAgeFirstLicensed${index}`]: {
                    path: `${basePath}.ageFirstLicensed`,
                    value: vehicleOperatorVM.ageFirstLicensed.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'ageFirstLicensed.value', value); updateSubmissionVM(submissionVM) }
                },
                [`excludedDriverEmailAddress${index}`]: {
                    path: `${basePath}.emailAddress`,
                    value: vehicleOperatorVM.emailAddress.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'emailAddress.value', value); updateSubmissionVM(submissionVM) },
                    disabled: disableEmailAddress(vehicleOperatorVM)
                }
            };
        });

        const watercraftOperatorsDetailsOverride = watercraftOperatorsVM.map((vehicleOperatorVM, index) => {
            const basePath = getBasePath(vehicleOperatorVM);
            return {
                [`watercraftOperatorName${index}`]: {
                    content: `${getPersonFullName(vehicleOperatorVM)} (${translator(messages.watercraftOperatorNumber, { watercraftOperatorNumber: index + 1 })})`
                },
                [`watercraftOpLicenseNumber${index}`]: {
                    path: `${basePath}.licenseNumber`,
                    value: vehicleOperatorVM.licenseNumber.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'licenseNumber.value', value); onLicenseNumberChange(); updateSubmissionVM(submissionVM) }
                },
                [`watercraftStateLicensed${index}`]: {
                    path: `${basePath}.licenseState`,
                    availableValues: formatAvailableValues(vehicleOperatorVM.licenseState),
                    value: vehicleOperatorVM.licenseState.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'licenseState.value', value); updateSubmissionVM(submissionVM) }
                }
            };
        });

        return Object.assign({}, ...vehicleDetailsOverride, ...householdMembersDetailsOverride, ...excludedDriversDetailsOverride, ...watercraftOperatorsDetailsOverride);
    };

    const validateEmailAddress = (accountContactDetailsVm) => {
        const account = accountContactDetailsVm;
        let emailAddress1 =  _.get(account, 'emailAddress.value');
        if(emailAddress1){
            emailAddress1=emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification Api Called");
                if(res == true){
                    _.set(account, 'emailVerified_Ext.value', true);
                    _.set(account, 'emailAddress.value', emailAddress1);
                    if(_.get(account, 'value.isPrimaryNamedInsured') === true){
                        _.set(submissionVM, 'bindData.contactEmail.value', emailAddress1);
                    }
                }
                else{
                    _.set(account, 'emailVerified_Ext.value', false);
                    _.set(account, 'emailAddress.value', emailAddress1+' ');
                    updateShowErrors(true);
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(messages.invalidEmail), 'invalidEmail');
                _.set(account, 'emailAddress.value', emailAddress1);
                if(_.get(account, 'value.isPrimaryNamedInsured') === true){
                    _.set(submissionVM, 'bindData.contactEmail.value', emailAddress1);
                }
                _.set(account, 'emailVerified_Ext.value', false);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }
        
    };

    const handleOnBlur = (vehicleOperatorVM) => {
        validateEmailAddress(vehicleOperatorVM);
    }

    const validateUmUimFields = () => {
        const isUmUimAutoPolicies = _.get(submissionVM, 'lobData.personalUmbrella.umUimCov_ML.isUMUIMOnAllAutoPolicies.value');
        const isUmUimLimits = _.get(submissionVM, 'lobData.personalUmbrella.umUimCov_ML.isUMUIMLimitsEqualAutoLimits.value');

        clearBlockAlerts('UM/UIM Error');

        if (isUmUimCoverageSelected && !isUmUimAutoPolicies) {
            const message = translator(messages.umUimULAutoPoliciesHardStopErrorMessage);
            addErrorAlert(message, 'UM/UIM Error');
            window.scrollTo(0, 0);
            return true;
        }

        if (isUmUimCoverageSelected && !isUmUimLimits) {
            const message = translator(messages.umUimULAutoLimitsHardStopErrorMessage);
            addErrorAlert(message, 'UM/UIM Error');
            window.scrollTo(0, 0);
            return true;
        }

        return false;
    }

    const validateEsignFields = () => {

        const esignValue = _.get(
            submissionVM,
            'bindData.esignature_ML.esign_Ext.value'
        );
    
        const esignatureOption = _.get(
            submissionVM,
            'bindData.esignature_ML.esignatureOptions.value'
        );
    
        const mobileNumber = _.get(
            submissionVM,
            'bindData.esignature_ML.mobileNumber_Ext.value'
        );
        const mobileDigits = (mobileNumber || '').replace(/\D/g, '');
        const isMobileNumberInvalid = mobileDigits.length > 0 && mobileDigits.length !== 10;
    
        clearBlockAlerts('E-Signature Error');

        if (_.isNil(esignValue)) {
            const message = translator(messages.esignRequiredErrorMessage);
            addErrorAlert(message, 'E-Signature Error');
            window.scrollTo(0, 0);
            return true;
        }
    

        if (esignValue === true && _.isNil(esignatureOption)) {
            const message = translator(messages.esignOptionRequiredErrorMessage);
            addErrorAlert(message, 'E-Signature Error');
            window.scrollTo(0, 0);
            return true;
        }
        const esignatureOptionCode = _.isObject(esignatureOption)
            ? esignatureOption.code
            : esignatureOption;
        if (
            esignValue === true &&
            esignatureOptionCode === 'Text' &&
            (_.isEmpty(mobileNumber) || isMobileNumberInvalid)
        ) {
            const message = translator(isMobileNumberInvalid ? messages.invalidMobileNumber : messages.mobileNumberRequiredErrorMessage);
            addErrorAlert(message, 'E-Signature Error');
            window.scrollTo(0, 0);
            return true;
        }
        if(esignValue === true && esignatureOptionCode === 'Text'){
            const esignAck = _.get(submissionVM, `bindData.esignature_ML.esignTextAck_Ext.value`);
            if (_.isUndefined(esignAck) || esignAck == undefined) {
                addErrorAlert(
                    translator(messages.requiredFieldEsignAck),
                    'E-Signature Error',
                );
                window.scrollTo(0, 0);
                return true;
            }
        }
        return false;
    };
 

    const emailTrim = (vehicleOperatorVM, event) => {
        let currEmail = _.get(vehicleOperatorVM, 'emailAddress.value');
        if(currEmail !== '' && currEmail !== undefined){
            currEmail = currEmail.trim();
            _.set(vehicleOperatorVM, 'emailAddress.value', currEmail);
        }
        let emailAddress1 =  event.target.value;
        if(emailAddress1 !== '' && emailAddress1 !== undefined){
            emailAddress1 = emailAddress1.trim();
            event.target.value = emailAddress1;
        }
    }

    const generateRatedDriversDetailsOverride = useCallback(() => {
        const updateRatedDriversDriverLicenseNumber = (value, path) => {
            _.set(submissionVM, path, value);
            updateSubmissionVM();
        };

        const overrides = ratedDriversVM.map((vehicleOperatorVM, index) => {
            const basePath = getBasePath(vehicleOperatorVM);
            return {
                [`ratedDriverName${index}`]: {
                    content: `${getPersonFullName(vehicleOperatorVM)} (${getDriverTypeDisplayName(vehicleOperatorVM.driverType.value.code, true)} #${index + 1})`
                },
                [`ratedDriversEmailAddressDiv${index}`]: {
                    visible: isEmailAddressVisible(vehicleOperatorVM) === true,
                },
                [`ratedDriverEmailScriptContainer${index}`]: {
                    visible: false
                },
                [`ratedDriversOccupation${index}`]: {
                    path: `${basePath}.occupationType`,
                    availableValues: formatAvailableValues(vehicleOperatorVM.occupationType),
                    value: vehicleOperatorVM.occupationType.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'occupationType.value', value); updateSubmissionVM(submissionVM)}
                },
                [`ratedDriversDriverLicenseNumber${index}`]: {
                    path: `${basePath}.licenseNumber`,
                    value: _.get(vehicleOperatorVM, 'licenseNumber.value'),
                    onValueChange: updateRatedDriversDriverLicenseNumber
                },
                [`ratedDriversStateLicensed${index}`]: {
                    path: `${basePath}.licenseState`,
                    availableValues: formatAvailableValues(vehicleOperatorVM.licenseState),
                    value: vehicleOperatorVM.licenseState.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'licenseState.value', value); updateSubmissionVM(submissionVM) }
                },
                [`ratedDriverEmailAddress${index}`]: {
                    path: `${basePath}.emailAddress`,
                    value: vehicleOperatorVM.emailAddress.value,
                    onValueChange: (value) => { _.set(vehicleOperatorVM, 'emailAddress.value', value); updateSubmissionVM(submissionVM) },
                    disabled: disableEmailAddress(vehicleOperatorVM),
                    onBlur: () => {handleOnBlur(vehicleOperatorVM)},
                    onFocus: (event) => {emailTrim(vehicleOperatorVM, event)}
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [ratedDriversVM, submissionVM, updateSubmissionVM, getBasePath, getPersonFullName, getDriverTypeDisplayName, formatAvailableValues]);
 
    const overrides = {
        vehiclesIterable: {
            data: vehiclesVM
        },
        ratedDriversIterable: {
            data: ratedDriversVM
        },
        householdMembersIterable: {
            data: householdMembersVM
        },
        excludedDriversIterable: {
            data: excludedDriversVM
        },
        watercraftOperatorsIterable: {
            data: watercraftOperatorsVM
        },
        additionalInterestList: {
            model: _.get(submissionVM, 'lobData.personalUmbrella.coverables.additionalInterests'),
            updateViewModel: updateSubmissionVM,
            onValueChange: writeValue,
            path: 'lobData.personalUmbrella.coverables',
            showValidationErrors: showErrors,
            onValidate,
            isPersonalUmbrella: true,
            additionalInterestAvailableCandidatesML
        },
        liabilityLossVehicleOpIterable: {
            data: vehicleOperatorsVM
        },
        priorInsuranceQuestionSet: {
            value: priorInsuranceQuestionSetData,
            onValueChange: onPriorInsuranceQuestionValueChange_Ext,
            onBlur: handlePriorInsuranceOnBlur,
            onValidate,
            showErrors,
            visible: isPersonalUmbrella
        },
        nextDescription: {
            content: nextStepText_Ext()
        },
        stickyContinueSection: {
            defaultContinueSectionId: 'footer',
            nextDescription: nextStepText_Ext(),
            onNext,
            disableNext:inValidVin?.length > 0 || disableNextButton
        },
        ...generateOverrides(),
        ...generateRatedDriversDetailsOverride(),
        esignContainer: {
            visible: isModernProduct && isEsignEnabledForState,
            model: submissionVM,
            updateWizardData,
            product: "personalUmbrella"
        },
        uwIssueContainer: {
            visible: isUWIssuesPanelVisible,
            uwIssues: blockingUwIssues,
            jobID: submissionVM.quoteID.value,
            publicID: _.get(submissionVM, 'value.publicID'),
            afterIssuesRefreshedCallback: checkForDisableNextButton,
            submissionVM,
            history
        },
        umUimContainer: {
            visible: isModernProduct
        },
        isUmUimAvailed: {
            value: isUmUimCoverageSelected
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyfootercomponent'
            disableNext={inValidVin?.length > 0}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                onValidationChange={onValidate}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

PUPAdditionalInfoToPurchasePage.propTypes = wizardProps;
export default PUPAdditionalInfoToPurchasePage;
